import * as React from 'react'
import './style.css'


export class Dialog extends React.Component {

  render() {
    const { show, dialogConfig, children } = this.props
    return show ? (
      <div className="dialog">
        <div className="dialog-mark">
        </div>
        <div className="dialog-box">
          <div
            className="dialog-title"
          >
            {dialogConfig && dialogConfig.title}
          </div>
          <div className="dialog-content">
            {dialogConfig && dialogConfig.content}
            {children}
          </div>
          <div className="dialog-footer">
            <div
              className="dialog-cancel"
              onClick={dialogConfig && dialogConfig.onCancel}
            >
              {dialogConfig && dialogConfig.text && dialogConfig.text[0] ? dialogConfig.text[0] : '取消'}
            </div>
            <div
              className="dialog-submit"
              onClick={dialogConfig && dialogConfig.onSubmit}
            >
              {dialogConfig && dialogConfig.text && dialogConfig.text[1] ? dialogConfig.text[1] : '确认'}
            </div>
          </div>
        </div>
      </div>
      ) : null
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/index.js